import React, { useState, useEffect } from 'react'
import { Container, Image } from 'react-bootstrap'
import { CLASSES } from '../../../assets/styles/classes'
import PlusIcon from '../../../assets/icons/common/plus-white.svg'
import TicketIcon from '../../../assets/icons/sidebar/ticket.svg'
import { useDispatch, useSelector } from 'react-redux'
import Table from '../../../components/table/Table'
import SearchFilter from '../../../components/extras/SearchFilter'
import { useNavigate } from 'react-router-dom'
import ActionElements from '../../../components/extras/ActionElements'
import { PAGINATION_TYPES } from '../../../utils/constants'
import { AssetService } from '../../../services'
import getPaginationData from '../../../store/actions/pagination'
import { setCurrentPage } from '../../../store/reducers'
import { addOrUpdatePaginationData } from '../../../store/actions/pagination'
import REST_API from '../../../services/API_Routes'
import ButtonWithIcon from '../../../components/common/ButtonWithIcon'
import { preConfirmAlert } from '../../../utils/helperFunctions'

export default function CustomerAssets() {
  const navigate = useNavigate()
  const columns = [
    {
      name: 'Asset Name',
      minWidth: '180px',
      cell: ({ asset_name }) => asset_name,
    },
    {
      name: 'Brand',
      // minWidth: '180px',
      cell: ({ asset_brand_name }) => asset_brand_name,
    },
    {
      name: 'Model',
      // minWidth: '180px',
      cell: ({ asset_model_no }) => asset_model_no,
    },
    {
      name: 'Quantity',
      // minWidth: '180px',
      cell: ({ asset_qty }) => asset_qty,
    },
    {
      name: 'Price',
      // minWidth: '180px',
      cell: ({ asset_price }) => asset_price,
    },

    {
      name: 'Actions',
      width: '120px',
      center: true,
      cell: (row) => (
        <ActionElements
          id={row.userId || 1}
          editClick={() => navigate(`/assets/edit/${row.asset_id}`)}
          deleteClick={() => deleteClick(row.asset_id)}
        />
      ),
    },
  ]

  const dispatch = useDispatch()
  const { items, currentPage, rowsPerPage } = useSelector(
    ({ pagination }) => pagination[PAGINATION_TYPES.ASSET],
  )
  const isLoading = useSelector(({ loader }) => loader[PAGINATION_TYPES.ASSET])
  const [searchQuery, setSearchQuery] = useState({})

  useEffect(() => {
    dispatch(
      getPaginationData({
        key: PAGINATION_TYPES.ASSET,
        ServiceName: AssetService,
        page: currentPage,
        per_page: rowsPerPage,
        ...searchQuery,
      }),
    )
  }, [currentPage, rowsPerPage, searchQuery])

  const handleSearch = (query) => {
    setSearchQuery(query)
    dispatch(
      setCurrentPage({
        key: PAGINATION_TYPES.ASSET,
        currentPage: 1,
      }),
    )
  }

  const deleteClick = async (id) => {
    const { isConfirmed } = await preConfirmAlert({
      title: 'Are you sure to delete?',
      text: "You won't be able to revert this!",
      confirmButtonText: 'Yes, Delete it',
      denyButtonText: 'No',
      confirmButton: 'btn btn-danger px-5',
      denyButton: 'btn btn-primary ms-3 px-5',
    })
    if (isConfirmed) {
      dispatch(
        addOrUpdatePaginationData({
          id,
          key: PAGINATION_TYPES.ASSET,
          ServiceName: AssetService,
          primaryKey: 'asset_id',
          route: REST_API.ASSET_DELETE + id,
          value: { asset_active: 0 },
        }),
      )
    }
  }

  return (
    <Container fluid className='p-4 py-2 mt-2'>
      <div>
        <div className={CLASSES.content_between + ' flex-wrap gap-3'}>
          <h4 className={CLASSES.items_center + 'mb-0'}>
            <Image src={TicketIcon} className='me-3' /> All Asset list
          </h4>
          <ButtonWithIcon
            onClick={() => navigate('/assets/create')}
            className={'border-0'}
            label='Add New Asset'
            icon={PlusIcon}
          />
        </div>

        <div className='mb-5 mt-3 pt-4 border-radius-10 black-shadow-15'>
          <div className={CLASSES.content_between + 'px-4 mb-4'}>
            <div className='px-0 px-md-2'>
              <SearchFilter
                handleSearch={handleSearch}
                placeholder='Asset Name'
              />
            </div>

            {/* <div className={CLASSES.content_between + 'px-0 px-md-2'}>
              <DropDownX label='Sort by : ' />
            </div> */}
          </div>

          <Table
            columns={columns}
            data={items}
            progressPending={isLoading}
            paginationType={PAGINATION_TYPES.ASSET}
            customStyle={{
              rows: {
                style: {
                  borderTop: '0px solid #E0E0E0',
                  borderBottom: '1px solid #E0E0E0 !important',
                  display: 'flex !important',
                  alignItems: 'center !important',
                  padding: 5,
                },
              },
            }}
            conditionalRowStyles={[
              {
                when: ({ asset_active }) => asset_active == 0,
                style: {
                  backgroundColor: '#FFB0B0',
                },
              },
            ]}
          />
        </div>
      </div>
    </Container>
  )
}
